<template>
  <v-row
    class="fill-height"
    no-gutters
  >
    <template v-for="(modal, index) in cardOptionsModals">
      <DynamicModalComponent
        v-if="modal.props.value"
        :key="index"
        :component-name="modal.componentName"
        :custom-props="{...modal.props, defaultOptions:rawSeries}"
        :events="modal.events"
      />
    </template>

    <PieChart
      :request-status="requestStatus"
      :series="series"
      :title="title"
      :item-id="itemId"
      :has-custom-filter="true"
      :open-filter="openTagViewModal"
      :filter-button="filterButton"
      name-icon="view"
      class="make-a-copy"
      v-bind="$attrs"
      @reload="getData"
    />
  </v-row>
</template>

<script>
import PieChart from '@/components/cards/models/PieChart';
import { mapActions, mapGetters } from 'vuex';
import { OPERATION } from '@/services/charts-service';
import EventBus from '@/utils/event-bus';
import cardsModel from '@/mixins/cards-model';
import DynamicModalComponent from '@/components/modal-model/DynamicModalComponent';

export default {
  name: 'TagSharePieChart',
  components: {
    PieChart,
    DynamicModalComponent,
  },
  mixins: [
    cardsModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      rawSeries: [],
      filterButton: this.$t('components.models.PieChart.label.viewTags.button_viewTags'),
      series: [],
      cardModalMethods: {
        openTagViewModal: this.openTagViewModal,
      },
      customFilterData: null,
    };
  },
  computed: {
    ...mapGetters('dashboard', ['activeDashboardFilters', 'activeGlobalFilter', 'activeDashboard']),
  },
  created() {
    this.loadSavedTags();
    this.getData();
  },
  methods: {
    ...mapActions('cards', ['getChartsService']),
    ...mapActions('dashboard', ['saveViewTags']),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getChartsService({
        itemId: this.itemId,
        method: 'getAggregatedData',
        points_parser: 'points',
        params: {
          grouping: ['tag'],
          operators: OPERATION.COUNT,
          datePortion: this.getDatePortion(options),
        },
      })
        .then((response) => {
          this.rawSeries = response?.points || [];
          this.applyFilter(this.customFilterData);
          this.requestStatus = 'success';
          if (this.$attrs.filter) {
            this.filter = this.$attrs.filter;
          }

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch((err) => {
          console.error(err);
          this.requestStatus = 'error';
        });
    },
    applyFilter(filterData) {
      this.customFilterData = filterData;
      const filterValues = filterData?.tags_view?.value || [];
      let filteredData = this.rawSeries;
      this.saveViewTags({ tagsView: filterValues, itemId: this.itemId }).catch(err => {
        console.error('Failed to save tags:', err);
      });

      if (filterValues && filterValues.length > 0) {
        filteredData = this.rawSeries.filter(item => filterValues.includes(item.x));
      }

      this.series = filteredData.map(item => ({
        name: item.x,
        y: item.z,
      }));
    },
    openTagViewModal() {
      this.showTagViewModal = true;
    },
    loadSavedTags() {
      try {
        const card = this.activeDashboard.data.cards.find(card => card.id === this.itemId);
        if (card && card.tagsView) {
          this.applyFilter({ tags_view: { value: card.tagsView } });
        }
      } catch (err) {
        console.error('Failed to load saved tags:', err);
      }
    },
  },
};
</script>
